<template>
  <section class="mid-cnt" style="padding-bottom:90px;">
    <loadingIcon v-if="loading" />
    <div v-else-if="!ads.length " class="tab-cnt prdt-list">
      <div class="noads-data">
        <img src="../assets/images/nodata.svg" alt="" />
        <p>{{$t('Create ad for your Promotion')}}</p>
        <!-- <button class="button " @click="$router.push('/create-ad-form?intent=LINK_OPEN&MediaType=1')">
          {{$t('Create Ad')}}
        </button> -->
        <button class="button " @click="adsOptionPopup = !adsOptionPopup">
          {{$t('Create Ad')}}
        </button>
      </div>
    </div>
    <div v-else-if="ads.length" class="tab-cnt prdt-list">
      <!-- <div class="totalCount">
        <span>{{ads.length}}</span>
        <p>Total Ads</p>
      </div> -->
      <ul>
        <li
          v-for="(ad, index) in ads"
          :key="index"
          @click.prevent="
            $router.push(`/ad-details?AdNo=${ad.campaignIdentifier}`)
          "
        >
        <div class="list-item">
          <span class="img-box">
            <img
              :src="ad.campaignMedia[0].mediaURL"
              v-if="ad.campaignMedia.length"
            />
            <img v-if="ad.leadMedia" :src="ad.leadMedia.mediaURL" alt="" />
            <img src="../assets/images/watermark1.jpg" v-else />
          </span>
          <div class="title-blk">
            <h2>
              {{ ad.name }}
            </h2>
            <span class="text-date">{{ extractDate(ad.startDate) }}</span>
            <span
              class="status"
              :class="new Date().getTime() > ad.endDate ? 'expire' : 'active'"
            >
              {{ new Date().getTime() > ad.endDate ? "Expired" : ad.status === 1 ? "Pending" : "Active" }}
            </span>
          </div>

          <p>
            {{ ad.description }}
          </p>
        </div>
          <div class="button-box">
            <!-- <div class="item">
              Selling Price:<strong>{{ ad.sellingPrice }}</strong>
            </div> -->

            <div class="item">
              <button
                class="button"
                @click.stop="goToEdit(ad.shopId,ad.campaignIdentifier,ad.campaignAction.action,ad.productMedia)"
              >
                {{ $t('Edit detail') }}
              </button>
              <!-- button -->
              <button
                :id="`btn${index}`"
                class="button delete-btn"
                @click.stop="adsDelete(ad.campaignIdentifier, index)"
              >
                {{$t('Delete')}}
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- <button class="button bottom-button" @click="$router.push('/create-ad-form?intent=LINK_OPEN&MediaType=1')" v-if="ads.length">
          + {{$t('Create Ad')}}
        </button> -->
        <button class="button bottom-button" @click="adsOptionPopup = !adsOptionPopup" v-if="ads.length">
          + {{$t('Create Ad')}}
        </button>
        
    <Toaster :dataValue="toasterData" />
    <ads-option-pop-up v-if="adsOptionPopup" @closeAdsOption="adsOptionPopup = !adsOptionPopup"/>
  </section>
</template>

<script>
import constant from '../utils/constant';
import {GET} from "../utils/HttpStatusCodeConst"
import ApiRequest from "../services/ApiRequest";
import Toaster from "../components/Toaster";
import loadingIcon from "../components/Icons/loadingIcon";
import {SessionHelper} from "../services/Session";
import AdsOptionPopUp from './AdsOptionPopUp.vue';

export default {
  name: "AdsListing",
  data() {
    return {
      loading: false,
      toasterData: {},
      disable: false,
      selectedIndex: null,
      ads: [],
      adsOptionPopup:false
    };
  },
  components: {
    Toaster,
    loadingIcon,
    AdsOptionPopUp
  },
  methods: {
    goToEdit(shopId,adId,action,productMedia){
      if(shopId){
        if(productMedia){
          this.$router.push({
                  path: '/create-ad-form',
                  query: { AdId: adId,AdsType:'Product' },
                })
        }else{
          this.$router.push({
                  path: '/create-ad-form',
                  query: { AdId: adId,AdsType:'Shop' },
                })
        }
        
      }else{
        if(action === "WHATS_APP_OPEN"){
          this.$router.push(`/create-ad-form?AdId=${adId}&AdsType=WhatsApp`)
        }else if(action === "WHATS_APP_GROUP_OPEN"){
          this.$router.push(`/create-ad-form?AdId=${adId}&AdsType=WhatsappLink`)
        }else if(action === "LINK_OPEN"){
          this.$router.push(`/create-ad-form?AdId=${adId}&AdsType=WebSite`)
        }
      }
      
    },
    fetchAdsList(){
      this.loading = true;
      ApiRequest(constant.ADS_BASE_API_URL,`/campaign/userAds`, GET).then((data) => {
        if (data.httpStatus === 200) {
          SessionHelper.setCookie("loadWallet", "false");
          this.ads = data.data;
          this.loading = false;
        } else {
          SessionHelper.setCookie("loadWallet", "false");
          this.toasterData = {
            status: true,
            msg: data.message,
            timeoutMs: "5000",
            color: "#000",
          };
           if(data.message === 'Invalid Token'){
             this.toasterData = {
              status: true,
              msg: data.message,
              timeoutMs: "5000",
              color: "#000",
            };
            // SessionHelper.refreshJwtToken()
            this.loading = false;
          }
          if(SessionHelper.getCookie('JWT-TOKEN') !== 'null'){
            this.fetchAdsList();
          }
          this.loading = false;
        }
      }).catch(() => {
        this.toasterData = {
          status: true,
          msg: "Invalid Token",
          timeoutMs: "5000",
          color: "#000",
        };
        this.loading = false;
      });
    },

  adsDelete(identifier, index) {
    document.getElementById(`btn${index}`).classList.add("disable");
    ApiRequest(constant.ADS_BASE_API_URL,`/campaign/delete/${identifier}`, "delete").then((data) => {
        if (data.httpStatus) {
          if (data.httpStatus === 200) {
            this.fetchAdsList(index);
          }
          this.toasterData = {
            status: true,
            msg: data.message,
            timeoutMs: "5000",
            color: "#ff6600",
          };
          if(data.message === 'Invalid Token'){
            console.log('=token error==')
            SessionHelper.refereshJwtToken()
            if(SessionHelper.getCookie('JWT-TOKEN') !== 'null'){
              this.adsDelete();
            }
          }
        }
      }); 
    },
    extractDate(timestamp) {
      const month = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      return (
        new Date(timestamp).getDate() +
        " " +
        month[new Date(timestamp).getMonth()] +
        " " +
        new Date(timestamp).getFullYear()
      );
    },
  },

  mounted() {
    this.fetchAdsList();
  }
};
</script>
<style lang="scss" scoped>
.mid-cnt{
  position: relative;
    height: calc(100vh - 132px);
    overflow: scroll;
}
.button.bottom-button{
  border-radius: 5px;
    width: auto;
    margin-top: 8px;
    background: green;
    font-weight: 500;
    font-size: 0.875em;
    padding: 8px 24px;
    position: fixed;
    right: 15px;
    bottom: 90px;
}
.prdt-list{
  li{
    padding: 0 !important;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #eaeaea;
    .list-item{
      padding:8px;
    }
    .status{
      width: calc(16% - -23px);
    }
    &:last-child{
      margin-bottom: 130px !important;
    }
  }
  .button-box{
    padding: 8px;
    background: #f1f1f1;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    button{
      background: #fff !important;
      border: 1px solid #dddddd !important;
      color: #505050 !important;
      &.delete-btn{
        margin-left: 8px !important;
      }
    }
  }
}

@import "@/assets/scss/ads-detail.scss";
</style>
